import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[appDraggable]',
})
export class DraggableDirective implements OnInit {
    private element: HTMLElement;

    private subscriptions: Subscription[] = [];

    initialX: number;
    initialY: number;
    currentX = 0;
    currentY = 0;

    constructor(
        private elementRef: ElementRef,
        @Inject(DOCUMENT) private document: any
    ) {}

    ngOnInit(): void {
        this.element = this.elementRef.nativeElement as HTMLElement;
        //this.initDbClick();
        this.initDrag();
    }

    initDrag(): void {
        const dragStart$ = fromEvent<MouseEvent>(this.element, 'mousedown');
        const dragEnd$ = fromEvent<MouseEvent>(this.document, 'mouseup');
        const drag$ = fromEvent<MouseEvent>(this.document, 'mousemove').pipe(
            takeUntil(dragEnd$)
        );

        let dragSub: Subscription;

        const dragStartSub = dragStart$.subscribe((event: MouseEvent) => {
            this.initialX = event.clientX - this.currentX;
            this.initialY = event.clientY - this.currentY;

            dragSub = drag$.subscribe((event: MouseEvent) => {
                event.preventDefault();
                this.element.classList.add('dragged');

                this.currentX = event.clientX - this.initialX;
                this.currentY = event.clientY - this.initialY;

                this.element.style.transform =
                    'translate3d(' +
                    this.currentX +
                    'px, ' +
                    this.currentY +
                    'px, 0)';
            });
        });

        const dragEndSub = dragEnd$.subscribe(() => {
            this.initialX = this.currentX;
            this.initialY = this.currentY;
            //this.element.classList.remove('dragged');
            if (dragSub) {
                dragSub.unsubscribe();
            }
        });

        this.subscriptions.push.apply(this.subscriptions, [
            dragStartSub,
            dragSub,
            dragEndSub,
        ]);
    }

    // initDbClick(): void {
    //   const click$ = fromEvent<MouseEvent>(this.element, 'dblclick');
    //   click$.subscribe((event: MouseEvent) => {
    //     event.preventDefault();
    //     console.log(event);
    //     this.element.style.transform = 'translate3d(0, 0, 0)';
    //     this.element.classList.remove('dragged');
    //     this.currentX = 0;
    //     this.currentY = 0;
    //   });
    // }

    // ngOnDestroy(): void {
    //   this.subscriptions.forEach((s) => s.unsubscribe());
    // }
}
